import './styles/simonsLayout.css';
import {Link} from "react-router-dom";

export default function ListReference({listItem}) {
    if (listItem.linkRef.startsWith("http", 0))
        return (<li>
            <a href={listItem.linkRef}
               target="_blank"
               rel="noreferrer"
               title={listItem.title}
            >{listItem.text}</a>
        </li>);
    else
        return (<li>
            <Link to={listItem.linkRef} title={listItem.title}>
                {listItem.text}
            </Link>
        </li>)
}
